import { appFormUtil } from 'modules/common';
import {
  StyledRadioButtonField,
  StyledTextField
} from 'modules/components/layer01';



export type GeneralProjectInformationFieldsProps<T extends object, K extends keyof T> = {
  form: appFormUtil.InferReturn<T>;
  fieldNames: K[];
  projectId?: string;
};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object, K extends keyof T>(props: GeneralProjectInformationFieldsProps<T, K>) => {

  return (
    <>
      {props.fieldNames.map((field, i) => {
        const defaultProps = props.form.genFieldProps(field);
        if (defaultProps.type === 'radio') {
          return (
            <StyledRadioButtonField.FC
              key={`${i}`}
              form={props.form}
              fieldName={field}
              label='Create Rooms Another Time'
              trueLabel='Yes'
              falseLabel='No'
              includeFormLabel={true}
            />
          );
        }
        return (
          <StyledTextField.FC
            key={`${i}`}
            {...defaultProps}
            disabled={field === 'estimatedProjectStartDate' && !!props.projectId}
          />
        );
      })}
    </>
  );
};
